import 'waypoints/lib/noframework.waypoints.min.js';
import { CountUp } from 'countup.js';

var counters = document.querySelectorAll(".counter__number");

counters.forEach(function (counter) {
  new Waypoint({
    element: counter,
    handler: function () {
      var countTo = counter.getAttribute("data-number");
      var countSuffix = counter.getAttribute("data-suffix");
      var countPrefix = counter.getAttribute("data-prefix");
        
      var options = {
        useEasing: true,
        useGrouping: true,
        speed: 2000,
        separator: ",",
        decimal: ".",
        suffix: "",
        prefix: "",
      };

      if (countPrefix) options.prefix = countPrefix;
      if (countSuffix) options.suffix = countSuffix;

      var countUp = new CountUp(counter, countTo, options);
      countUp.start();
      this.destroy();
    },
    offset: "bottom-in-view",
  });
});